import {useNavigate} from "react-router-dom";
import {common as stringsCommon, deleteAccountModal as strings} from "strings";

import Button from "components/Button";
import PageTitle from "components/PageTitle";
import StyledModal from "components/StyledModal";

import {useDeleteUser} from "liberty-core/api/react-query/user";

import {signOut} from "lib/auth";

import styles from "./DeleteAccountModal.module.css";

type Props = {
  visible: boolean;
  onClickClose: () => void;
};

export default function DeleteAccountModal(props: Props) {
  const {mutateAsync: deleteUser, isLoading} = useDeleteUser();
  const navigate = useNavigate();

  return (
    <StyledModal
      visible={props.visible}
      className={styles.styledModal}
      overlayClassName={styles.overlay}
    >
      <div className={styles.modalContent}>
        <PageTitle className={styles.pageTitle}>{strings.title}</PageTitle>
        <div className={styles.warningText}>{strings.warning}</div>
        <Button
          className={styles.cancelButton}
          disabled={isLoading}
          onClick={props.onClickClose}
        >
          {stringsCommon.cancel}
        </Button>
        <Button
          className={styles.deleteButton}
          loading={isLoading}
          variant="unfilled"
          onClick={() => {
            deleteUser()
              .then(signOut)
              .then(() => navigate("/"))
              .catch((err) =>
                alert(
                  err?.response?.data?.generic?.join("\n") ??
                    strings.errorMessage,
                ),
              );
          }}
        >
          {strings.deleteAccount}
        </Button>
      </div>
    </StyledModal>
  );
}
